<template>
    <div class="Field__Component">
        <div>
            <slot>
                <a v-if="field.Id == 'questions'" :href="`/${field.RouteName || field.Id}/${item.id}`" target="_blank" rel="noopener noreferrer"
                    :style="{ textDecoration: 'underline' }">
                    <b-icon style="color: #337ab7;" icon="cog"></b-icon>
                </a>
                <router-link v-else :style="{ textDecoration: 'underline' }"
                    :to="`/${field.RouteName || field.Id}/${item.id}`"><b-icon style="color: #337ab7;"
                        icon="cog"></b-icon></router-link>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value', 'field', 'item'],
};
</script>

<style scoped></style>
